import { useState } from "react";
import httpService from "../services/httpService"; // your axios wrapper

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';

const NotFound = () => {

    return (
        <Container className="d-flex justify-content-center align-items-center min-vh-100">
            <Card style={{
                width: '50%',
                overflow: 'hidden',
                margin: 0
            }}>
                <Row className="g-0">
                    <Col>
                        <div className='p-5 text-center'>
                            <h1>Page Not Found 404</h1>
                        </div>
                    </Col>
                </Row>
            </Card>
        </Container>
    );
};

export default NotFound;
